import Flickity from 'flickity';

export default {
  init($element) {
  },
  finalize($element) {
    const $scrollbar = $element.find('.anchor-scrollbar-wrap .anchor-scrollbar');
    var carouselPercentage = 0;

    // Initialise anchor links carousel, if applicable
    const $anchorLinksCarousel = $element.find('.anchor-links-carousel');
    if ($anchorLinksCarousel.length > 0) {
      const anchorLinksFlickity = new Flickity($anchorLinksCarousel.get()[0], {
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        cellAlign: 'left',
        on: {
          ready: function() {
            if (this.slides) {
              carouselPercentage = ($anchorLinksCarousel.width() / this.slides[this.slides.length - 1].x) * 100;
              $scrollbar.css({ width: carouselPercentage + '%' });

              if (carouselPercentage > 100) {
                // Scrollbar not needed, hide it
                $scrollbar.parent().hide();
              } else {
                // Scrollbar needed, show it
                $scrollbar.parent().show();
              }
            }
          },
        },
      });

      anchorLinksFlickity.on('scroll', function(progress) {
        progress = Math.min(Math.max(progress, 0), 1) * 100;
        
        const ratio = (progress / 100) * carouselPercentage;
        const left = progress - ratio;

        $scrollbar.css({ left: left + '%' });
      });

      // On scroll set currently active anchor link where appropriate
      var allAnchorLinks = [];
      var currentlyActiveAnchorLink = -1;

      setTimeout(() => {
        $('.shared-anchor-link').each(function() {
          let thisAnchorLink = {
            slug: $(this).find('a').prop('name'),
            y: $(this).find('a').offset().top,
          };

          allAnchorLinks.push(thisAnchorLink);
        });

        $anchorLinksCarousel.css({ 'visibility': 'visible' });
      }, 500);

      $(window).on('scroll', function() {
        const scrollY = $(document).scrollTop();
        currentlyActiveAnchorLink = -1;

        allAnchorLinks.forEach((anchorLink, index) => {
          if (scrollY + 80 >= anchorLink.y) {
            currentlyActiveAnchorLink = index;
          }
        });

        // Remove all active classes from anchor bar
        $element.find('.anchor-link').removeClass('is-active');

        if (currentlyActiveAnchorLink > -1) {
          $element.find(`.anchor-link[href="#${allAnchorLinks[currentlyActiveAnchorLink].slug}"]`).addClass('is-active');
        }
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/shared/anchorLinks.js